import * as React from "react";
import axios from "axios";

export function ContactActions({ contact, sectionType, onSuccess }) {
  const [showMenu, setShowMenu] = React.useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false);

  const handleEdit = () => {
    const event = new CustomEvent('openContactModal', {
      detail: { 
        sectionType: sectionType,
        contactData: contact
      }
    });
    window.dispatchEvent(event);
    setShowMenu(false);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`https://projects-dev.nettlescs.com:5000/api/contacts/${contact.id}`);
      onSuccess();
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error('Error deleting contact:', error);
    }
  };

  // Close menus when clicking outside
  React.useEffect(() => {
    const handleClickOutside = () => {
      setShowMenu(false);
      setShowDeleteConfirm(false);
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div className="relative">
      <button 
        className="p-1 hover:bg-gray-100 rounded-full"
        onClick={(e) => {
          e.stopPropagation();
          setShowMenu(!showMenu);
          setShowDeleteConfirm(false);
        }}
      >
        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
        </svg>
      </button>

      {showMenu && !showDeleteConfirm && (
        <div className="absolute right-0 mt-1 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-10">
          <button
            className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100 flex items-center"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit();
            }}
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
            Edit
          </button>
          <button
            className="w-full px-4 py-2 text-sm text-left text-red-600 hover:bg-gray-100 flex items-center"
            onClick={(e) => {
              e.stopPropagation();
              setShowDeleteConfirm(true);
              setShowMenu(false);
            }}
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Delete
          </button>
        </div>
      )}

      {showDeleteConfirm && (
        <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 p-3 z-10">
          <p className="text-sm text-gray-600 mb-2">Are you sure you want to delete this contact?</p>
          <div className="flex justify-end space-x-2">
            <button
              className="px-2 py-1 text-xs text-gray-600 hover:bg-gray-100 rounded"
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteConfirm(false);
              }}
            >
              Cancel
            </button>
            <button
              className="px-2 py-1 text-xs text-white bg-red-600 hover:bg-red-700 rounded"
              onClick={(e) => {
                e.stopPropagation();
                handleDelete();
              }}
            >
              Delete
            </button>
          </div>
        </div>
      )}
    </div>
  );
} 